module.exports = __webpack_public_path__ + "static/media/responsibility-social-impact.f9a368d5.jpg";